module.exports = __webpack_public_path__ + "static/media/gelEsfoliante.bccc6651.jpeg";